export default __webpack_public_path__ + "static/media/css-.dbd31fe1.svg";